import { Footer } from 'nhsuk-react-components';
import { LINK_SPI_GUIDANCE, LINK_CONTACT_SPI_TEAM_EMAIL } from '../../constants/links';

export default function PageFooter() {
  return (
    <Footer>
      <Footer.List>
        <li className="nhsuk-footer__list-item">
          Version:
          {' '}
          {import.meta.env.VITE_APP_VERSION || 'unknown'}
        </li>
        <li className="nhsuk-footer__list-item">
          Updated:
          {' '}
          {import.meta.env.VITE_APP_LAST_RELEASED || 'unknown'}
        </li>
      </Footer.List>
      <Footer.List>
        <Footer.ListItem
          href={LINK_SPI_GUIDANCE}
          target="_blank"
          rel="noreferrer"
          aria-label="Open SPI guidance in a new tab"
          data-testid="footer-nav-spi-guidance"
        >
          <span className="nhsuk-u-visually-hidden">
            Open SPI guidance in a new tab
          </span>
          <img src="/right-arrow-green.svg" alt="Right arrow icon" className="nhsuk-footer__icon" />
          <span className="nhsuk-u-margin-left-2">SPI guidance</span>
        </Footer.ListItem>
        <Footer.ListItem
          href={`mailto:${LINK_CONTACT_SPI_TEAM_EMAIL}`}
          aria-label="Open mail client to send email message to SPI team"
          data-testid="footer-nav-contact-spi-team"
        >
          <span className="nhsuk-u-visually-hidden">
            Open mail client to send email message to SPI team
          </span>
          <img src="/right-arrow-green.svg" alt="Right arrow icon" className="nhsuk-footer__icon" />
          <span className="nhsuk-u-margin-left-2">Contact SPI team</span>
        </Footer.ListItem>
      </Footer.List>
    </Footer>
  );
}
